import { Link } from "react-router-dom";
import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";

const AREAS = [
  {
    city: "Fredericksburg",
    state: "VA",
    desc: "Our home base. We provide full-service tree removal, trimming, and stump grinding throughout Fredericksburg and surrounding neighborhoods.",
    services: ["Tree Removal", "Tree Trimming", "Stump Grinding", "Emergency Service"],
  },
  {
    city: "Stafford County",
    state: "VA",
    desc: "Serving all of Stafford County including Aquia Harbour, Hampton Oaks, and Mountain View communities.",
    services: ["Tree Removal", "Tree Trimming", "Stump Grinding"],
  },
  {
    city: "Spotsylvania",
    state: "VA",
    desc: "Professional tree care throughout Spotsylvania County, including Lake Anna, Wilderness, and Massaponax areas.",
    services: ["Tree Removal", "Tree Trimming", "Stump Grinding"],
  },
  {
    city: "King George",
    state: "VA",
    desc: "Reliable tree service for King George County homeowners. Fast response and free on-site estimates available.",
    services: ["Tree Removal", "Tree Trimming", "Stump Grinding"],
  },
  {
    city: "Culpeper",
    state: "VA",
    desc: "Serving Culpeper County with professional arborist services. Large rural properties and estate tree work welcome.",
    services: ["Tree Removal", "Tree Trimming", "Lot Clearing"],
  },
  {
    city: "Warrenton",
    state: "VA",
    desc: "Tree services throughout Warrenton and Fauquier County. From single trees to multi-acre clearing.",
    services: ["Tree Removal", "Tree Trimming", "Stump Grinding"],
  },
  {
    city: "Manassas",
    state: "VA",
    desc: "Full tree care services in Manassas and Manassas Park. Urban and suburban tree work of all types.",
    services: ["Tree Removal", "Tree Trimming", "Stump Grinding"],
  },
  {
    city: "Woodbridge",
    state: "VA",
    desc: "Serving Woodbridge, Dale City, and Lake Ridge communities throughout Prince William County.",
    services: ["Tree Removal", "Tree Trimming", "Stump Grinding"],
  },
  {
    city: "Dumfries",
    state: "VA",
    desc: "Professional tree removal and care for Dumfries and Triangle area homeowners.",
    services: ["Tree Removal", "Tree Trimming", "Stump Grinding"],
  },
  {
    city: "Orange County",
    state: "VA",
    desc: "Tree services extending to Orange County VA. Rural and estate properties welcome.",
    services: ["Tree Removal", "Tree Trimming", "Lot Clearing"],
  },
  {
    city: "Montross",
    state: "VA",
    desc: "Serving Westmoreland County and the Montross area with professional residential tree services.",
    services: ["Tree Removal", "Tree Trimming", "Stump Grinding"],
  },
  {
    city: "Rappahannock County",
    state: "VA",
    desc: "Full tree care services for Rappahannock County property owners, including Sperryville and Washington, VA.",
    services: ["Tree Removal", "Tree Trimming", "Stump Grinding"],
  },
];

export default function ServiceAreasPage() {
  return (
    <>
      <Header />
      <main>
        <section className="py-20 bg-[#1a3a2e] text-center">
          <div className="max-w-4xl mx-auto px-4">
            <span className="text-[#e8632a] font-bold text-sm uppercase tracking-widest block mb-3">Where We Work</span>
            <h1 className="text-5xl lg:text-6xl font-black text-white mb-4">
              Tree Service Areas in Northern Virginia
            </h1>
            <p className="text-white/70 text-xl">
              From our Fredericksburg base, we serve homeowners and businesses across Northern Virginia and the surrounding region.
            </p>
          </div>
        </section>

        {/* Map + intro */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl font-black text-[#1e1e1e] mb-4">
                Proudly Serving 50+ Miles Around Fredericksburg, VA
              </h2>
              <p className="text-gray-600 leading-relaxed mb-6">
                Based in Fredericksburg, Virginia, Diversified Tree Services LLC provides professional tree removal, trimming, and stump grinding throughout Northern Virginia. We travel to serve you — whether you're in Stafford County, Culpeper, Woodbridge, or beyond.
              </p>
              <p className="text-gray-600 leading-relaxed mb-8">
                Not sure if we serve your area? Give us a call at <a href="tel:+15407764488" className="font-bold text-[#e8632a]">(540) 776-4488</a> — we very likely do, and we're happy to confirm with a free over-the-phone consultation.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#e8632a] text-white font-bold rounded-lg uppercase tracking-wide hover:bg-[#d0541e] transition-all cursor-pointer"
              >
                Request Free Estimate <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="relative rounded-2xl overflow-hidden h-80 border-4 border-white shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d198752.24834!2d-77.5982!3d38.3032!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b6c196de1e7d11%3A0x6a56c86d9c0a1b4d!2sFredericksburg%2C%20VA!5e0!3m2!1sen!2sus!4v1700000000001"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Diversified Tree Services service map"
              ></iframe>
            </div>
          </div>
        </section>

        {/* Area cards */}
        <section className="py-20 bg-[#f8f6f3]">
          <div className="max-w-7xl mx-auto px-4 lg:px-8">
            <h2 className="text-4xl font-black text-[#1e1e1e] text-center mb-12">
              Cities &amp; Counties We Serve
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {AREAS.map((area) => (
                <div key={area.city} className="bg-white rounded-2xl p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 flex items-center justify-center bg-[#e8632a]/10 rounded-lg flex-shrink-0">
                      <i className="ri-map-pin-fill text-[#e8632a]"></i>
                    </div>
                    <h3 className="font-black text-[#1e1e1e]">{area.city}, {area.state}</h3>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{area.desc}</p>
                  <div className="flex flex-wrap gap-2">
                    {area.services.map((s) => (
                      <span key={s} className="text-xs font-semibold bg-[#f8f6f3] text-[#1a3a2e] px-2 py-1 rounded-full border border-gray-200">
                        {s}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 bg-[#e8632a] text-center">
          <div className="max-w-3xl mx-auto px-4">
            <h2 className="text-4xl font-black text-white mb-4">Don't See Your City?</h2>
            <p className="text-white/80 mb-8">We likely serve your area. Give us a call and we'll confirm right away.</p>
            <a href="tel:+15407764488" className="inline-flex items-center gap-2 px-8 py-4 bg-white text-[#e8632a] font-black rounded-lg uppercase tracking-wide hover:bg-gray-100 cursor-pointer whitespace-nowrap">
              <i className="ri-phone-fill"></i>(540) 776-4488
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
